import { StyledRow } from "App/global-style";
import styled from "styled-components";

export const StyledInput = styled.input`
  align-self: flex-start;
  margin-right: 8px;
  margin-top: 5px;
`;

interface SelectableVariant {
  removePaddingLeft?: boolean;
}
export const HeaderWrapper = styled.div<SelectableVariant>`
  box-sizing: border-box;
  display: flex;
  padding-bottom: 12px;
  width: 100%;

  @media screen and (min-width: 426px) {
    padding-left: ${({ removePaddingLeft }) =>
      removePaddingLeft ? "0px" : "14px"};
  }

  & label {
    font-size: 18px;

    /* font-weight: 700; */
    font-weight: 600;
  }
`;

export const CoverageCardHeader = styled(StyledRow)`
  @media screen and (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
  }
`;
